
import React from 'react';
import { Link } from 'react-router-dom';
import { Utensils } from 'lucide-react';
import { Button } from '@/components/ui/button';

const GuestHeader: React.FC = React.memo(() => {
  return (
    <header className="border-b border-golden-light bg-cream shadow-sm w-full py-3 px-4">
      <div className="flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 text-xl font-bold text-charcoal font-playfair">
          <Utensils className="h-7 w-7 text-sage" />
          <span className="text-sage lowercase">forkast</span>
        </Link>
        
        <div className="flex items-center gap-1 md:gap-3">
          <Link to="/auth/register">
            <Button className="px-2 py-1 md:px-6 md:py-2 text-xs md:text-base bg-sage hover:bg-sage-dark text-cream font-inter font-medium">
              <span className="hidden sm:inline">Sign Up</span>
              <span className="sm:hidden">Sign Up</span>
            </Button>
          </Link>
          <Link to="/auth/login">
            <Button variant="outline" className="px-2 py-1 md:px-4 md:py-2 text-xs md:text-base border-sage text-sage hover:bg-sage hover:text-cream font-inter">
              Sign In
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
});

GuestHeader.displayName = 'GuestHeader';

export default GuestHeader;
